import { TrieNode } from './trieNode';

class Trie {
  constructor() {
    this.root = new TrieNode();
  }

  insert(phrase) {
    let node = this.root;
    phrase.split('').forEach((char) => {
      if (!node.children[char]) {
        node.children[char] = new TrieNode();
      }
      node = node.children[char];
    });

    node.isEndOfWord = true;
  }

  // Helper method to check if a character is a word boundary
  // eslint-disable-next-line class-methods-use-this
  isWordBoundary(char) {
    return !char || /[^\w]/.test(char);
  }

  searchInText(text, start) {
    let node = this.root;
    let end = start;
    let longestMatchEnd = -1;

    // Check if we're at a word boundary to start the match
    const prevChar = start > 0 ? text[start - 1] : null;
    if (!this.isWordBoundary(prevChar)) {
      return -1; // Not at a word boundary, no match
    }

    while (end < text.length && node.children[text[end]]) {
      node = node.children[text[end]];
      end += 1;

      if (node.isEndOfWord) {
        // Check if this is followed by a word boundary
        if (end === text.length || this.isWordBoundary(text[end])) {
          longestMatchEnd = end; // Update longest match found
        }
      }
    }
    return longestMatchEnd; // Return longest match
  }
}

export { Trie };
